import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AppThemes } from '../types/enums/app-theme.enum';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private currentTheme: ReplaySubject<AppThemes> = new ReplaySubject(1);
  constructor() {}

  setTheme(theme: AppThemes) {
    if (theme === AppThemes.LIGHT) {
      document.body.classList.remove('dark');
      document
        .getElementById('favicon')
        .setAttribute('href', 'assets/black-favicon.png');
    } else {
      document.body.classList.add('dark');
      document
        .getElementById('favicon')
        .setAttribute('href', 'assets/white-favicon.png');
    }

    this.currentTheme.next(theme);
  }

  getTheme() {
    return this.currentTheme;
  }
}
